import * as _ from 'lodash';

var languages = [{
    "name": "Abkhaz",
    "native_name": "аҧсуа",
    "key": "abkhaz"
}, {
    "name": "Afar",
    "native_name": "Afaraf",
    "key": "afar"
}, {
    "name": "Afrikaans",
    "native_name": "Afrikaans",
    "key": "afrikaans"
}, {
    "name": "Akan",
    "native_name": "Akan",
    "key": "akan"
}, {
    "name": "Albanian",
    "native_name": "Shqip",
    "key": "albanian"
}, {
    "name": "Amharic",
    "native_name": "አማርኛ",
    "key": "amharic"
}, {
    "name": "Arabic",
    "native_name": "العربية",
    "key": "arabic"
}, {
    "name": "Aragonese",
    "native_name": "Aragonés",
    "key": "aragonese"
}, {
    "name": "Armenian",
    "native_name": "Հայերեն",
    "key": "armenian"
}, {
    "name": "Assamese",
    "native_name": "অসমীয়া",
    "key": "assamese"
}, {
    "name": "Avaric",
    "native_name": "авар мацӀ, магӀарул мацӀ",
    "key": "avaric"
}, {
    "name": "Avestan",
    "native_name": "avesta",
    "key": "avestan"
}, {
    "name": "Aymara",
    "native_name": "aymar aru",
    "key": "aymara"
}, {
    "name": "Azerbaijani",
    "native_name": "azərbaycan dili",
    "key": "azerbaijani"
}, {
    "name": "Bambara",
    "native_name": "bamanankan",
    "key": "bambara"
}, {
    "name": "Bashkir",
    "native_name": "башҡорт теле",
    "key": "bashkir"
}, {
    "name": "Basque",
    "native_name": "euskara, euskera",
    "key": "basque"
}, {
    "name": "Belarusian",
    "native_name": "Беларуская",
    "key": "belarusian"
}, {
    "name": "Bengali",
    "native_name": "বাংলা",
    "key": "bengali"
}, {
    "name": "Bihari",
    "native_name": "भोजपुरी",
    "key": "bihari"
}, {
    "name": "Bislama",
    "native_name": "Bislama",
    "key": "bislama"
}, {
    "name": "Bosnian",
    "native_name": "bosanski jezik",
    "key": "bosnian"
}, {
    "name": "Breton",
    "native_name": "brezhoneg",
    "key": "breton"
}, {
    "name": "Bulgarian",
    "native_name": "български език",
    "key": "bulgarian"
}, {
    "name": "Burmese",
    "native_name": "ဗမာစာ",
    "key": "burmese"
}, {
    "name": "Catalan; Valencian",
    "native_name": "Català",
    "key": "catalan_valencian"
}, {
    "name": "Chamorro",
    "native_name": "Chamoru",
    "key": "chamorro"
}, {
    "name": "Chechen",
    "native_name": "нохчийн мотт",
    "key": "chechen"
}, {
    "name": "Chichewa; Chewa; Nyanja",
    "native_name": "chiCheŵa, chinyanja",
    "key": "chichewa_chewa_nyanja"
}, {
    "name": "Chinese",
    "native_name": "中文 (Zhōngwén), 汉语, 漢語",
    "key": "chinese"
}, {
    "name": "Chuvash",
    "native_name": "чӑваш чӗлхи",
    "key": "chuvash"
}, {
    "name": "Cornish",
    "native_name": "Kernewek",
    "key": "cornish"
}, {
    "name": "Corsican",
    "native_name": "corsu, lingua corsa",
    "key": "corsican"
}, {
    "name": "Cree",
    "native_name": "ᓀᐦᐃᔭᐍᐏᐣ",
    "key": "cree"
}, {
    "name": "Croatian",
    "native_name": "hrvatski",
    "key": "croatian"
}, {
    "name": "Czech",
    "native_name": "česky, čeština",
    "key": "czech"
}, {
    "name": "Danish",
    "native_name": "dansk",
    "key": "danish"
}, {
    "name": "Divehi; Dhivehi; Maldivian;",
    "native_name": "ދިވެހި",
    "key": "divehi_dhivehi_maldivian_"
}, {
    "name": "Dutch",
    "native_name": "Nederlands, Vlaams",
    "key": "dutch"
}, {
    "name": "English",
    "native_name": "English",
    "key": "english"
}, {
    "name": "Esperanto",
    "native_name": "Esperanto",
    "key": "esperanto"
}, {
    "name": "Estonian",
    "native_name": "eesti, eesti keel",
    "key": "estonian"
}, {
    "name": "Ewe",
    "native_name": "Eʋegbe",
    "key": "ewe"
}, {
    "name": "Faroese",
    "native_name": "føroyskt",
    "key": "faroese"
}, {
    "name": "Fijian",
    "native_name": "vosa Vakaviti",
    "key": "fijian"
}, {
    "name": "Finnish",
    "native_name": "suomi, suomen kieli",
    "key": "finnish"
}, {
    "name": "French",
    "native_name": "français, langue française",
    "key": "french"
}, {
    "name": "Fula; Fulah; Pulaar; Pular",
    "native_name": "Fulfulde, Pulaar, Pular",
    "key": "fula_fulah_pulaar_pular"
}, {
    "name": "Galician",
    "native_name": "Galego",
    "key": "galician"
}, {
    "name": "Georgian",
    "native_name": "ქართული",
    "key": "georgian"
}, {
    "name": "German",
    "native_name": "Deutsch",
    "key": "german"
}, {
    "name": "Greek, Modern",
    "native_name": "Ελληνικά",
    "key": "greek_modern"
}, {
    "name": "Guaraní",
    "native_name": "Avañeẽ",
    "key": "guarani"
}, {
    "name": "Gujarati",
    "native_name": "ગુજરાતી",
    "key": "gujarati"
}, {
    "name": "Haitian; Haitian Creole",
    "native_name": "Kreyòl ayisyen",
    "key": "haitian_haitian_creole"
}, {
    "name": "Hausa",
    "native_name": "Hausa, هَوُسَ",
    "key": "hausa"
}, {
    "name": "Hebrew (modern)",
    "native_name": "עברית",
    "key": "hebrew_modern"
}, {
    "name": "Herero",
    "native_name": "Otjiherero",
    "key": "herero"
}, {
    "name": "Hindi",
    "native_name": "हिन्दी",
    "key": "hindi"
}, {
    "name": "Hinglish",
    "native_name": "Hinglish",
    "key": "hinglish"
}, {
    "name": "Hiri Motu",
    "native_name": "Hiri Motu",
    "key": "hiri_motu"
}, {
    "name": "Hungarian",
    "native_name": "Magyar",
    "key": "hungarian"
}, {
    "name": "Interlingua",
    "native_name": "Interlingua",
    "key": "interlingua"
}, {
    "name": "Indonesian",
    "native_name": "Bahasa Indonesia",
    "key": "indonesian"
}, {
    "name": "Irish",
    "native_name": "Gaeilge",
    "key": "irish"
}, {
    "name": "Igbo",
    "native_name": "Asụsụ Igbo",
    "key": "igbo"
}, {
    "name": "Inupiaq",
    "native_name": "Iñupiaq, Iñupiatun",
    "key": "inupiaq"
}, {
    "name": "Ido",
    "native_name": "Ido",
    "key": "ido"
}, {
    "name": "Icelandic",
    "native_name": "Íslenska",
    "key": "icelandic"
}, {
    "name": "Italian",
    "native_name": "Italiano",
    "key": "italian"
}, {
    "name": "Inuktitut",
    "native_name": "ᐃᓄᒃᑎᑐᑦ",
    "key": "inuktitut"
}, {
    "name": "Japanese",
    "native_name": "日本語 (にほんご／にっぽんご)",
    "key": "japanese"
}, {
    "name": "Javanese",
    "native_name": "basa Jawa",
    "key": "javanese"
}, {
    "name": "Kannada",
    "native_name": "ಕನ್ನಡ",
    "key": "kannada"
}, {
    "name": "Kanuri",
    "native_name": "Kanuri",
    "key": "kanuri"
}, {
    "name": "Kashmiri",
    "native_name": "कश्मीरी, كشميري‎",
    "key": "kashmiri"
}, {
    "name": "Kazakh",
    "native_name": "Қазақ тілі",
    "key": "kazakh"
}, {
    "name": "Khmer",
    "native_name": "ភាសាខ្មែរ",
    "key": "khmer"
}, {
    "name": "Kikuyu, Gikuyu",
    "native_name": "Gĩkũyũ",
    "key": "kikuyu_gikuyu"
}, {
    "name": "Kinyarwanda",
    "native_name": "Ikinyarwanda",
    "key": "kinyarwanda"
}, {
    "name": "Kirghiz, Kyrgyz",
    "native_name": "кыргыз тили",
    "key": "kirghiz_kyrgyz"
}, {
    "name": "Komi",
    "native_name": "коми кыв",
    "key": "komi"
}, {
    "name": "Kongo",
    "native_name": "KiKongo",
    "key": "kongo"
}, {
    "name": "Korean",
    "native_name": "한국어 (韓國語), 조선말 (朝鮮語)",
    "key": "korean"
}, {
    "name": "Kurdish",
    "native_name": "Kurdî, كوردی‎",
    "key": "kurdish"
}, {
    "name": "Kwanyama, Kuanyama",
    "native_name": "Kuanyama",
    "key": "kwanyama_kuanyama"
}, {
    "name": "Latin",
    "native_name": "latine, lingua latina",
    "key": "latin"
}, {
    "name": "Luxembourgish, Letzeburgesch",
    "native_name": "Lëtzebuergesch",
    "key": "luxembourgish_letzeburgesch"
}, {
    "name": "Luganda",
    "native_name": "Luganda",
    "key": "luganda"
}, {
    "name": "Limburgish, Limburgan, Limburger",
    "native_name": "Limburgs",
    "key": "limburgish_limburgan_limburger"
}, {
    "name": "Lingala",
    "native_name": "Lingála",
    "key": "lingala"
}, {
    "name": "Lao",
    "native_name": "ພາສາລາວ",
    "key": "lao"
}, {
    "name": "Lithuanian",
    "native_name": "lietuvių kalba",
    "key": "lithuanian"
}, {
    "name": "Luba-Katanga",
    "native_name": "Luba Katanga",
    "key": "luba_katanga"
}, {
    "name": "Latvian",
    "native_name": "latviešu valoda",
    "key": "latvian"
}, {
    "name": "Manx",
    "native_name": "Gaelg, Gailck",
    "key": "manx"
}, {
    "name": "Macedonian",
    "native_name": "македонски јазик",
    "key": "macedonian"
}, {
    "name": "Malagasy",
    "native_name": "Malagasy fiteny",
    "key": "malagasy"
}, {
    "name": "Malay",
    "native_name": "bahasa Melayu, بهاس ملايو‎",
    "key": "malay"
}, {
    "name": "Malayalam",
    "native_name": "മലയാളം",
    "key": "malayalam"
}, {
    "name": "Maltese",
    "native_name": "Malti",
    "key": "maltese"
}, {
    "name": "Māori",
    "native_name": "te reo Māori",
    "key": "maori"
}, {
    "name": "Marathi (Marāṭhī)- Deprecated",
    "native_name": "मराठी",
    "key": "marathi_mar_h_"
}, {
    "name": "Marathi (Marāṭhī) - New",
    "native_name": "मराठी",
    "key": "marathi"
}, {
    "name": "Marshallese",
    "native_name": "Kajin M̧ajeļ",
    "key": "marshallese"
}, {
    "name": "Mongolian",
    "native_name": "монгол",
    "key": "mongolian"
}, {
    "name": "Nauru",
    "native_name": "Ekakairũ Naoero",
    "key": "nauru"
}, {
    "name": "Navajo, Navaho",
    "native_name": "Diné bizaad, Dinékʼehǰí",
    "key": "navajo_navaho"
}, {
    "name": "Norwegian Bokmål",
    "native_name": "Norsk bokmål",
    "key": "norwegian_bokmal"
}, {
    "name": "North Ndebele",
    "native_name": "isiNdebele",
    "key": "north_ndebele"
}, {
    "name": "Nepali",
    "native_name": "नेपाली",
    "key": "nepali"
}, {
    "name": "Ndonga",
    "native_name": "Owambo",
    "key": "ndonga"
}, {
    "name": "Norwegian Nynorsk",
    "native_name": "Norsk nynorsk",
    "key": "norwegian_nynorsk"
}, {
    "name": "Norwegian",
    "native_name": "Norsk",
    "key": "norwegian"
}, {
    "name": "Nuosu",
    "native_name": "Nuosuhxop",
    "key": "nuosu"
}, {
    "name": "South Ndebele",
    "native_name": "isiNdebele",
    "key": "south_ndebele"
}, {
    "name": "Occitan",
    "native_name": "Occitan",
    "key": "occitan"
}, {
    "name": "Ojibwe, Ojibwa",
    "native_name": "ᐊᓂᔑᓈᐯᒧᐎᓐ",
    "key": "ojibwe_ojibwa"
}, {
    "name": "Oromo",
    "native_name": "Afaan Oromoo",
    "key": "oromo"
}, {
    "name": "Oriya",
    "native_name": "ଓଡ଼ିଆ",
    "key": "oriya"
}, {
    "name": "Ossetian, Ossetic",
    "native_name": "ирон æвзаг",
    "key": "ossetian_ossetic"
}, {
    "name": "Panjabi, Punjabi - Deprecate",
    "native_name": "ਪੰਜਾਬੀ, پنجابی‎",
    "key": "panjabi_punjabi"
}, {
    "name": "Punjabi",
    "native_name": "ਪੰਜਾਬੀ",
    "key": "punjabi"
}, {
    "name": "Pāli",
    "native_name": "पाऴि",
    "key": "pali"
}, {
    "name": "Persian",
    "native_name": "فارسی",
    "key": "persian"
}, {
    "name": "Polish",
    "native_name": "polski",
    "key": "polish"
}, {
    "name": "Pushto",
    "native_name": "پښتو",
    "key": "pushto"
}, {
    "name": "Portuguese",
    "native_name": "Português",
    "key": "portuguese"
}, {
    "name": "Quechua",
    "native_name": "Runa Simi, Kichwa",
    "key": "quechua"
}, {
    "name": "Romansh",
    "native_name": "rumantsch grischun",
    "key": "romansh"
}, {
    "name": "Kirundi",
    "native_name": "kiRundi",
    "key": "kirundi"
}, {
    "name": "Romanian, Moldavian, Moldovan",
    "native_name": "română",
    "key": "romanian_moldavian_moldovan"
}, {
    "name": "Russian",
    "native_name": "русский язык",
    "key": "russian"
}, {
    "name": "Sanskrit",
    "native_name": "संस्कृतम्",
    "key": "sanskrit"
}, {
    "name": "Sardinian",
    "native_name": "sardu",
    "key": "sardinian"
}, {
    "name": "Sindhi",
    "native_name": "सिन्धी, سنڌي، سندھی‎",
    "key": "sindhi"
}, {
    "name": "Northern Sami",
    "native_name": "Davvisámegiella",
    "key": "northern_sami"
}, {
    "name": "Samoan",
    "native_name": "gagana faa Samoa",
    "key": "samoan"
}, {
    "name": "Sango",
    "native_name": "yângâ tî sängö",
    "key": "sango"
}, {
    "name": "Serbian",
    "native_name": "српски језик",
    "key": "serbian"
}, {
    "name": "Scottish",
    "native_name": "Gàidhlig",
    "key": "scottish"
}, {
    "name": "Shona",
    "native_name": "chiShona",
    "key": "shona"
}, {
    "name": "Sinhala, Sinhalese",
    "native_name": "සිංහල",
    "key": "sinhala_sinhalese"
}, {
    "name": "Slovak",
    "native_name": "slovenčina",
    "key": "slovak"
}, {
    "name": "Slovene",
    "native_name": "slovenščina",
    "key": "slovene"
}, {
    "name": "Somali",
    "native_name": "Soomaaliga, af Soomaali",
    "key": "somali"
}, {
    "name": "Southern Sotho",
    "native_name": "Sesotho",
    "key": "southern_sotho"
}, {
    "name": "Spanish; Castilian",
    "native_name": "español, castellano",
    "key": "spanish_castilian"
}, {
    "name": "Sundanese",
    "native_name": "Basa Sunda",
    "key": "sundanese"
}, {
    "name": "Swahili",
    "native_name": "Kiswahili",
    "key": "swahili"
}, {
    "name": "Swati",
    "native_name": "SiSwati",
    "key": "swati"
}, {
    "name": "Swedish",
    "native_name": "svenska",
    "key": "swedish"
}, {
    "name": "Tamil",
    "native_name": "தமிழ்",
    "key": "tamil"
}, {
    "name": "Telugu",
    "native_name": "తెలుగు",
    "key": "telugu"
}, {
    "name": "Tajik",
    "native_name": "тоҷикӣ, toğikī, تاجیکی‎",
    "key": "tajik"
}, {
    "name": "Thai",
    "native_name": "ไทย",
    "key": "thai"
}, {
    "name": "Tigrinya",
    "native_name": "ትግርኛ",
    "key": "tigrinya"
}, {
    "name": "Tibetan",
    "native_name": "བོད་ཡིག",
    "key": "tibetan"
}, {
    "name": "Turkmen",
    "native_name": "Türkmen, Түркмен",
    "key": "turkmen"
}, {
    "name": "Tagalog",
    "native_name": "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔",
    "key": "tagalog"
}, {
    "name": "Tswana",
    "native_name": "Setswana",
    "key": "tswana"
}, {
    "name": "Tonga",
    "native_name": "faka Tonga",
    "key": "tonga"
}, {
    "name": "Turkish",
    "native_name": "Türkçe",
    "key": "turkish"
}, {
    "name": "Tsonga",
    "native_name": "Xitsonga",
    "key": "tsonga"
}, {
    "name": "Tatar",
    "native_name": "татарча, tatarça, تاتارچا‎",
    "key": "tatar"
}, {
    "name": "Twi",
    "native_name": "Twi",
    "key": "twi"
}, {
    "name": "Tahitian",
    "native_name": "Reo Tahiti",
    "key": "tahitian"
}, {
    "name": "Uighur",
    "native_name": "Uyƣurqə, ئۇيغۇرچە‎",
    "key": "uighur"
}, {
    "name": "Ukrainian",
    "native_name": "українська",
    "key": "ukrainian"
}, {
    "name": "Urdu",
    "native_name": "اردو",
    "key": "urdu"
}, {
    "name": "Uzbek",
    "native_name": "zbek, Ўзбек, أۇزبېك‎",
    "key": "uzbek"
}, {
    "name": "Venda",
    "native_name": "Tshivenḓa",
    "key": "venda"
}, {
    "name": "Vietnamese",
    "native_name": "Tiếng Việt",
    "key": "vietnamese"
}, {
    "name": "Volapük",
    "native_name": "Volapük",
    "key": "volapuk"
}, {
    "name": "Walloon",
    "native_name": "Walon",
    "key": "walloon"
}, {
    "name": "Welsh",
    "native_name": "Cymraeg",
    "key": "welsh"
}, {
    "name": "Wolof",
    "native_name": "Wollof",
    "key": "wolof"
}, {
    "name": "Western Frisian",
    "native_name": "Frysk",
    "key": "western_frisian"
}, {
    "name": "Xhosa",
    "native_name": "isiXhosa",
    "key": "xhosa"
}, {
    "name": "Yiddish",
    "native_name": "ייִדיש",
    "key": "yiddish"
}, {
    "name": "Yoruba",
    "native_name": "Yorùbá",
    "key": "yoruba"
}, {
    "name": "Zhuang",
    "native_name": "Saɯ cueŋƅ, Saw cuengh",
    "key": "zhuang"
}];




export const ltmsConversationDefaultProps = {
    "brand_detail": null,
    "default_language": "english",
    "language": "english",
    "default_device": "phone",
    "languages": languages,
    "devices": ["phone", "desktop", "tablet"],
    "reactor_components": ["ltms-rating-bubble-reactor", "ltms-rating-bar-reactor", "ltms-rating-text-reactor", "ltms-rating-color-reactor"],
    "all_components": [],
    "is_dynamic_properties_enabled": false,
    "dynamic_properties_groups": [{
        "label": "Access Group",
        "value": "access_group"
    }, {
        "label": "Question Group",
        "value": "question_group"
    }],
    "props_to_delete": ["$$hashKey", "logicDetail", "visible-if", "is_mandatory_if", "server-visible-if", "is_primary_rating", "is_primary_comment", "is_user_info"],
    getSchemaOptions: (schema) => {
        var options = {
            theme: 'bootstrap3',
            iconlib: "fontawesome4",
            // Enable fetching schemas via ajax
            ajax: true,
            // The schema for the editor
            schema: schema.schema,
            // Seed the form with a starting value
            startval: schema.defaults,
            // Disable additional properties
            no_additional_properties: true,
            // Remove all "add row" buttons from arrays.
            disable_array_add: true,
            // Remove all "add row" buttons from arrays.
            disable_array_delete: true,
            disable_array_reorder: true,
            //Remove all collapse buttons from objects and arrays.
            disable_collapse: true,
            // Remove all Edit JSON buttons from objects.
            disable_edit_json: true,
            // Remove all Edit Properties buttons from objects.
            disable_properties: true,
            // Require all properties by default
            required_by_default: false,
            // Disable select2 - Default is false (Added for Reference)
            enable_select2: false
        }
        if (schema.options && schema.options.disable_array_add != null) {
            options.disable_array_add = schema.options.disable_array_add;
        }
        if (schema.options && schema.options.disable_edit_json != null) {
            options.disable_edit_json = schema.options.disable_edit_json;
        }
        if (schema.options && schema.options.disable_array_delete != null) {
            options.disable_array_delete = schema.options.disable_array_delete;
        }
        if (schema.options && schema.options.disable_properties != null) {
            options.disable_properties = schema.options.disable_properties;
        }
        if (schema.options && schema.options.disable_array_reorder != null) {
            options.disable_array_reorder = schema.options.disable_array_reorder;
        }
        return options;
    },

    /**
     * updatePageSequenceForFields: Method to update question's question_seq based on the flow in phone configuration
     * @param  {object} configuration    Details related to page flow, fields, screens etc.
     * @param  {string} defaultLanguage Default Language which is english for now.
     */
    updatePageSequenceForFields: (configuration, defaultLanguage) =>{
        try {
            var questionSequence = 0;
            var updatedFields = {};
            // The sequence of the questions will be considered based on the sequence in phone.
            if (!_.isEmpty(_.get(configuration, "flows.phone." + defaultLanguage))) {
                _.each(configuration["flows"]["phone"][defaultLanguage], (pageId:any)=> {
                    var pageParams = { "id": pageId, "deviceId": "phone", "questionSequence": questionSequence, "updatedFields": updatedFields };
                    var response = ltmsConversationDefaultProps.updateFieldSeqBasedOnUpdatedPageFlow(pageParams, configuration, defaultLanguage);
                    if (response) {
                        questionSequence = response["questionSequence"];
                        // merge updatedFields and object return from updateFieldSeqBasedOnUpdatedPageFlow
                        updatedFields = _.extend(updatedFields, response["updatedFields"]);
                        return true
                    } else {
                        // In case of exception break the each loop
                        return false;
                    }
                })
            }
        } catch (e) {
            console.log("Error: ltmsConversationDefaultProps: updatePageSequenceForFields", e);
        }
    },

    /**
     * updateFieldSeqBasedOnUpdatedPageFlow
     * @param  {object} pageParams : Data like page's id, device
     * @param  {object} configuration    Details related to page flow, fields, screens etc.
     * @param  {string} defaultLanguage Default Language which is english for now.
     * @return {number}            : Last sequence number which is assigned to field and the fields which are updated.
     */
    updateFieldSeqBasedOnUpdatedPageFlow: (pageParams, configuration, defaultLanguage)=> {
        try {
            var updatedFields = {};
            // Get Page detail through pageId and deviceId
            var pageDetail = ltmsConversationDefaultProps.getPageDetailById(configuration, defaultLanguage, pageParams["id"], pageParams["deviceId"]);
            if (pageDetail) {
                _.each(pageDetail["fields"], (fieldInPage) =>{
                    _.each(configuration["fields"], (field) =>{
                        if (field["field_id"] == fieldInPage["field_id"]) {
                            // increment the question sequence if field present in page.
                            pageParams["questionSequence"]++;
                            // assigned field's sequence with the same sequence if it is already updated else with the updated sequence.
                            field["question_seq"] = (updatedFields[field["field_id"]]) ? field["question_seq"] : pageParams["questionSequence"];
                            // update the key in updatedFields to keep the track of updated fileds.
                            updatedFields[field["field_id"]] = true;
                        }
                    });
                });
                return ({ "questionSequence": pageParams["questionSequence"], "updatedFields": updatedFields });
            } else {
                return null;
            }
        } catch (e) {
            console.log("Error: ltmsConversationDefaultProps: updateFieldSeqBasedOnUpdatedPageFlow", e);
            return null;
        }
    },

    /**
     * getPageDetailById: Method to get the detail of the page by pageId
     * @param  {object} configuration    Details related to page flow, fields, screens etc.
     * @param  {string} defaultLanguage Default Language which is english for now.
     * @param  {string} pageId           Id of the page the detail is needed
     * @param  {string} deviceId         Device for which page configuration is required
     * @return {object}                  Details of page if present else, null
     */
    getPageDetailById: function(configuration, defaultLanguage, pageId, deviceId) {
        try {
            if (_.get(configuration, "screens." + deviceId.toString() + '.' + defaultLanguage)) {
                return _.find(configuration["screens"][deviceId.toString()][defaultLanguage], { id: pageId });
            } else {
                return null
            }
        } catch (e) {
            console.log("Error: ltmsConversationDefaultProps: getPageDetailById()", e);
            return null;
        }

    }
} 